import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { dashboardAPI } from "../../../../Api/dashboardAPI";
import { toastError, ToastMessage } from "../../../../utils/toast";
import { AlumnosInitState } from "../../Slices/alumnosSlice";

export const inicializarAlumnosByIdPersonaList = createAsyncThunk(
  "dashboard/inicializarAlumnosByIdPersonaList",
  async (idPersonaList: number[], thunkAPI) => {
    try {
      console.log("inicializarAlumnosByIdPersonaList...");
      const response = await dashboardAPI.inicializarAlumnosByIdPersonaList(
        idPersonaList
      );
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const inicializarAlumnosPorIdPersonaListBuilder = (
  builder: ActionReducerMapBuilder<AlumnosInitState>
) => {
  builder.addCase(
    inicializarAlumnosByIdPersonaList.pending,
    (state, action) => {
      state.loading = true;
    }
  );
  builder.addCase(
    inicializarAlumnosByIdPersonaList.fulfilled,
    (state, action) => {
      console.log(
        "inicializarAlumnosByIdPersonaList fulfilled :>> ",
        action
      );
      state.loading = false;
    }
  );
  builder.addCase(
    inicializarAlumnosByIdPersonaList.rejected,
    (state, action) => {
      console.log("inicializarAlumnosByIdPersonaList rejected :>> ", action);
      toastError(ToastMessage.error);
      state.loading = false;
    }
  );
};
